var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisanew12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 25,
    viewBox: "0 0 54 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0446 19.9472L21.7161 4.27197H25.9885L23.3155 19.9472H19.0446ZM38.8117 4.65839C37.9651 4.34022 36.6387 4 34.9822 4C30.7607 3.99948 27.7864 6.12595 27.7615 9.17292C27.7376 11.4245 29.8846 12.6816 31.5053 13.4316C33.1682 14.1992 33.7275 14.6897 33.7194 15.3759C33.7088 16.4261 32.3912 16.9065 31.1632 16.9065C29.4533 16.9065 28.5447 16.669 27.1415 16.0838L26.5908 15.8342L25.9911 19.3433C26.9892 19.7811 28.8343 20.1603 30.7503 20.18C35.2415 20.1798 38.1572 18.0785 38.1904 14.8246C38.2065 13.0413 37.0682 11.6845 34.6033 10.5657C33.1098 9.84014 32.195 9.35692 32.2049 8.62249C32.2049 7.97085 32.979 7.27431 34.6516 7.27431C36.0491 7.25225 37.0607 7.55718 37.8494 7.87483L38.2324 8.05545L38.8114 4.65865L38.8117 4.65839ZM49.7679 4.28676H46.4663C45.4436 4.28676 44.678 4.56652 44.2288 5.5872L37.8836 19.9519H42.3701C42.3701 19.9519 43.1038 18.0208 43.2699 17.5968C43.7604 17.5968 48.1187 17.6035 48.7418 17.6035C48.8697 18.1522 49.2616 19.9522 49.2616 19.9522L53.2264 19.9519L49.7681 4.28676H49.7679ZM44.4992 14.3905C44.8527 13.4874 46.2014 10.0091 46.2014 10.0091C46.1764 10.0506 46.552 9.10155 46.7679 8.51297L47.057 9.86401C47.057 9.86401 47.8747 13.6062 48.0457 14.3907L44.4989 14.3905H44.4992ZM15.4612 4.28339L11.2784 14.9728L10.8325 12.8007C10.054 10.2964 7.62749 7.58365 4.91504 6.22534L8.74004 19.9337L13.2605 19.9283L19.9869 4.28339H15.4612Z",
    fill: "#191E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39822 4.27393H0.5086L0.454102 4.60014C5.81413 5.89719 9.36067 9.03318 10.8329 12.8006L9.33472 5.59745C9.07624 4.60481 8.32598 4.3087 7.39822 4.27393Z",
    fill: "#F7B600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisanew12);
export default __webpack_public_path__ + "static/media/visanew12.067b3a7662b5df83fa1eaf56b1030093.svg";
export { ForwardRef as ReactComponent };